/**
 * LandingPage.tsx
 * ---------------
 * Page wrapper for the landing screen.
 * - Resets progress on mount.
 */


import React, { useEffect } from 'react';
import Layout from '../components/common/Layout';
import Landing from '../components/Landing';
import { resetProgress } from '../utils/resetProgress';

const LandingPage = () => {
  useEffect(() => {
    resetProgress();
  }, []);
  return (
    <Layout>
      <Landing />
    </Layout>
  );
};

export default LandingPage;
